export default __webpack_public_path__ + "static/media/Mark-2-HUD-3D (Landing Site).e033283a.jpg";